import React, { useEffect, useState } from "react";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, powerbi } from "powerbi-client";
import logo from '../../../assets/img/loader4.gif'
const PowerBiReport = ({reportid,pagename}) => {
  const [powerbiReport, setPowerbiReport] = useState({});
  const [loading, setLoading] = useState(true);
  const [powerbiLoading, setpowerbiLoading] = useState(true);


  const powerbiReportData = async () => {
    try {
      const baseurl = `https://aays-cfo-dev-be-py.azurewebsites.net/cfo/report?reportId=${reportid}`;

      const response = await axios.get(baseurl);

      // Handling the response
      if (response.status === 200) {
        console.log("token generated successfully:", response.data);
        setLoading(false);
        setPowerbiReport(response.data);
        return response.data;
      } else {
        console.error(
          "Error posting FAQ data:",
          response.status,
          response.statusText
        );
        setLoading(false);
      }
    } catch (error) {
      console.error("Error posting FAQ data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    powerbiReportData();
  }, []);

  const embdData = (embeddedReport) => {
    window.report = embeddedReport;
    window.report.on("loaded", async function () {
      var reportPages = await window.report.getPages();
    });
  };

  const token = powerbiReport.embedToken;
  const url = powerbiReport.reportURL;
  const reportGId = powerbiReport.reportGuid;

  return (
    <div>
      <div style={{ height: "100vh" }}>
        {powerbiLoading && (
          <div
            style={{
              position: "absolute",
              background: "#ffffff",
              height: "100%",
              left: "0",
              right: "0",
              top: "0",
              bottom: "0",
              overflow: "hidden",
              borderRadius:"10px"
            }}
          >
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                height: "100%",
                overflow: "hidden",
                gap: "1rem",
              }}
            >
              <img src={logo} alt="logo" width={100}/>

              <span style={{color:"white"}}>Please wait...</span>
            </div>
          </div>
        )}

        {!loading && (
          <>
            <PowerBIEmbed
              embedConfig={{
                type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                id: reportGId,
                embedUrl: url,
                accessToken: token,
                pageName:`${pagename}`,
                tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
            
                settings: {
                  // navContentPaneEnabled:false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },

                  },
                  // background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    function () {
                      console.log("Report loaded");
                      setpowerbiLoading(false);
                    },
                  ],
                  [
                    "rendered",
                    function () {
                      console.log("Report rendered");
                    },
                  ],
                  [
                    "error",
                    function (event) {
                      console.log(event.detail);
                    },
                  ],
                  ["visualClicked", () => console.log("visual clicked")],
                  ["pageChanged", (event) => console.log(event)],
                ])
              }
              cssClassName={"report-style-class"}
              getEmbeddedComponent={embdData}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PowerBiReport;
